import { render, staticRenderFns } from "./infoInput.vue?vue&type=template&id=ad564d88&scoped=true&"
import script from "./infoInput.vue?vue&type=script&lang=js&"
export * from "./infoInput.vue?vue&type=script&lang=js&"
import style0 from "./infoInput.vue?vue&type=style&index=0&id=ad564d88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad564d88",
  null
  
)

export default component.exports